import { gsap, Dom } from '@univers-agency/jupiter'
import random from 'lodash.random'
import pull from 'lodash.pull'
import uniqueId from 'lodash.uniqueid'
import { Physics2DPlugin } from './physics2d'

gsap.registerPlugin(Physics2DPlugin)

export default class Confetti {
  constructor (app) {
    this.$el = Dom.find('.parade')
    this.app = app

    this.DECAY = 3
    this.SPREAD = 90
    this.GRAVITY = 1200 // 1200

    this.angle = 270
    this.shoot = false

    this.endFired = false

    this.dpr = window.devicePixelRatio || 1

    this.canvas = document.getElementById('confetti')
    this.confettiSpriteIds = []
    this.confettiSprites = {}

    this.setCanvasSize()

    this.colors = [
      '#FF0018',
      '#FFA52C',
      '#FFFF41',
      '#008018',
      '#0000F9',
      '#86007D',
      '#784f17',
      '#000000'
    ]
  }

  start () {
    // Use TweenLite tick event for the render loop
    gsap.ticker.add(this.render.bind(this))

    this.shootConfetti()
    this.addConfettiParticles(200, -90, 3500, random(0, 50), this.canvas.height)
    this.addConfettiParticles(200, -90, 3500, random(window.innerWidth - 50, window.innerWidth), this.canvas.height)
    // this.randomShots()
  }

  fireEnd () {
    if (this.endFired) {
      return
    }
    this.endFired = true
    this.addConfettiParticles(600, -90, 2500, random(0, 50), this.canvas.height)
    this.addConfettiParticles(600, -90, 2500, random(window.innerWidth - 50, window.innerWidth), this.canvas.height)
  }

  setCanvasSize () {
    this.ctx = this.canvas.getContext('2d')
    this.ctx.scale(this.dpr, this.dpr)

    this.canvas.width = window.innerWidth
    this.canvas.height = window.innerHeight
  }

  randomShots () {
    gsap.delayedCall(9, () => {
      this.addConfettiParticles(
        200, -90, 2500, random(0, window.innerWidth), this.canvas.height
      )
      this.randomShots()
    })
  }

  getDegAngle (x0, y0, x1, y1) {
    const y = y1 - y0
    const x = x1 - x0
    return Math.atan2(y, x) * (180 / Math.PI)
  }

  addClass (el, className) {
    el.classList.add(className)
  }

  removeClass (el, className) {
    el.classList.remove(className)
  }

  addConfettiParticles (amount, angle, velocity, x, y) {
    let i = 0
    while (i < amount) {
      // sprite
      const r = random(4, 6) * 2
      const d = random(10, 20) * 2

      const color = this.colors[random(0, this.colors.length - 1)]

      const tilt = random(10, -10)
      const tiltAngleIncremental = random(0.07, 0.05)
      const tiltAngle = 0

      const id = uniqueId()
      const sprite = {
        [id]: {
          angle,
          velocity,
          x,
          y,
          r,
          d,
          color,
          tilt,
          tiltAngleIncremental,
          tiltAngle
        }
      }

      Object.assign(this.confettiSprites, sprite)
      this.confettiSpriteIds.push(id)
      this.tweenConfettiParticle(id)
      i += 1
    }
  }

  tweenConfettiParticle (id) {
    const minAngle = this.confettiSprites[id].angle - this.SPREAD / 2
    const maxAngle = this.confettiSprites[id].angle + this.SPREAD / 2

    const minVelocity = this.confettiSprites[id].velocity / 4
    const maxVelocity = this.confettiSprites[id].velocity

    // Physics Props
    const velocity = random(minVelocity, maxVelocity)
    const angle = random(minAngle, maxAngle)
    const gravity = this.GRAVITY
    // const friction = random(0.1, 0.25);
    const friction = random(0.01, 0.05)
    const d = 0

    gsap.to(this.confettiSprites[id], {
      duration: this.DECAY,
      physics2D: {
        velocity,
        angle,
        gravity,
        friction
      },
      d,
      ease: 'power4.in',
      onComplete: () => {
        // remove confetti sprite and id
        pull(this.confettiSpriteIds, id)
        delete this.confettiSprites[id]
      }
    })
  }

  updateConfettiParticle (id) {
    const sprite = this.confettiSprites[id]

    const tiltAngle = 0.0005 * sprite.d

    sprite.angle += 0.01
    sprite.tiltAngle += tiltAngle
    sprite.tiltAngle += sprite.tiltAngleIncremental
    sprite.tilt = (Math.sin(sprite.tiltAngle - (sprite.r / 2))) * sprite.r * 2
    sprite.y += Math.sin(sprite.angle + sprite.r / 2) * 2
    sprite.x += Math.cos(sprite.angle) / 2
  }

  drawConfetti () {
    for (let x = 0; x < this.confettiSpriteIds.length; x += 1) {
      const id = this.confettiSpriteIds[x]
      const sprite = this.confettiSprites[id]

      this.ctx.beginPath()
      this.ctx.lineWidth = sprite.d / 2
      this.ctx.strokeStyle = sprite.color
      this.ctx.moveTo(sprite.x + sprite.tilt + sprite.r, sprite.y)
      this.ctx.lineTo(sprite.x + sprite.tilt, sprite.y + sprite.tilt + sprite.r)
      this.ctx.stroke()

      this.updateConfettiParticle(id)
    }
  }

  render () {
    this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height)
    this.drawConfetti()
  }

  shootConfetti () {
    requestAnimationFrame(this.shootConfetti.bind(this))
    if (this.shoot) {
      this.addConfettiParticles(
        10, -90, 5000, this.cannonPos, this.canvas.height
      )
    }
  }
}
